/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Block_BlueInputs */

const en_orders_review_block_blue = /** @type {(inputs: Orders_Review_Block_BlueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order is awaiting quality inspection. Complete QC before proceeding.`)
};

const es_orders_review_block_blue = /** @type {(inputs: Orders_Review_Block_BlueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pedido esta esperando inspeccion de calidad. Complete el control de calidad antes de continuar.`)
};

/**
* | output |
* | --- |
* | "Order is awaiting quality inspection. Complete QC before proceeding." |
*
* @param {Orders_Review_Block_BlueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_block_blue = /** @type {((inputs?: Orders_Review_Block_BlueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Block_BlueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_block_blue(inputs)
	return es_orders_review_block_blue(inputs)
});